import { PlansAndPurchaseTabWebComponent } from './component/PlansAndPurchaseTabWebComponent';
import { WEB_COMPONENT_PLANS_AND_PURCHASE_TAB } from '../../../../webcomponents.constants';

export { PlansAndPurchaseTabWebComponent };

window.customElements.define(WEB_COMPONENT_PLANS_AND_PURCHASE_TAB, PlansAndPurchaseTabWebComponent);
